import React from "react";
import { Navigate } from "react-router-dom";
import { usePlatformFeatureFlags } from "../../../context/PlatformFeatureFlagsContext";

const MESSAGES = {
  browseProjects: "Browsing projects is temporarily unavailable.",
  browseFreelancers: "Browsing freelancers is temporarily unavailable.",
  messaging: "Messaging is temporarily unavailable.",
  courses: "Courses are temporarily unavailable.",
  reviews: "Reviews are temporarily unavailable.",
  disputes: "Disputes are temporarily unavailable.",
  subscriptions: "Subscriptions are temporarily unavailable.",
  freelancerServices: "Freelancer services are temporarily unavailable.",
};

export function FeatureFlagRouteGuard({ flag, children, redirectTo = "/" }) {
  const { flags, loading } = usePlatformFeatureFlags();
  if (loading) return null;
  if (flags[flag] === false) {
    return (
      <Navigate
        to={redirectTo}
        replace
        state={{ featureDisabled: flag, featureMessage: MESSAGES[flag] }}
      />
    );
  }
  return children;
}
